import { __assign } from "tslib";
import React from 'react';
import SeriesHorizontal from './series-horizontal.component';
import SeriesVertical from './series-vertical.component';
import Label from '../label';
export var SeriesLegend = function (_a) {
    var layout = _a.layout, dataSeries = _a.dataSeries, position = _a.position, alignment = _a.alignment, typography = _a.typography, card = _a.card, onClick = _a.onClick, onActivate = _a.onActivate, onDeactivate = _a.onDeactivate, colorPalette = _a.colorPalette, disabledKeys = _a.disabledKeys, onOffsetUpdate = _a.onOffsetUpdate;
    var commonProps = {
        typography: typography,
        position: position,
        alignment: alignment,
        card: card,
        colorPalette: colorPalette,
        dataSeries: dataSeries,
    };
    var renderNodes = function (series, elementRef, itemWidth) {
        return series.map(function (_a, index) {
            var name = _a.name, color = _a.color;
            return (React.createElement("div", { key: name, ref: index === 0 ? elementRef : null },
                React.createElement(Label, { text: name, maxWidth: itemWidth, typography: typography, markColor: color, onClick: function (disabled, label) {
                        onClick(label, disabled, index);
                        if (onDeactivate && disabled)
                            onDeactivate();
                        if (onActivate && !disabled)
                            onActivate(label);
                    }, onMouseEnter: function (label) {
                        if (onActivate)
                            onActivate(label);
                    }, onMouseLeave: function () {
                        onDeactivate && onDeactivate();
                    }, isDisabled: disabledKeys.includes(name) })));
        });
    };
    return (React.createElement(React.Fragment, null, layout === 'horizontal' ? (React.createElement(SeriesHorizontal, __assign({}, commonProps, { renderNodes: renderNodes, onOffsetUpdate: function (offset) { return onOffsetUpdate && onOffsetUpdate(offset); } }))) : (React.createElement(SeriesVertical, __assign({}, commonProps, { renderNodes: renderNodes, onOffsetUpdate: function (offset) { return onOffsetUpdate && onOffsetUpdate(offset); } })))));
};
export default SeriesLegend;
